import type { SRT_RowSelectionState } from '@/shared/components/master-table'
import type { ScenarioModel } from '@/shared/generated'
import type { OnChangeFn } from '@tanstack/react-table'
import type { PricingCampaignTableRow } from '../model/types'

import { MasterTable } from '@/shared/components/master-table'
import { SRT_TableToolbar } from '@/shared/components/master-table/components/tools/SRT_TableToolbar'

import { useScenarioPricingCampaignsTable } from '../lib/useScenarioPricingCampaignsTable'

export const ScenarioPricingCampaignsTable = ({
	scenario,
	rowSelection,
	setRowSelection,
	data,
	isLoading,
}: {
	scenario?: ScenarioModel
	rowSelection: SRT_RowSelectionState
	setRowSelection: OnChangeFn<SRT_RowSelectionState>
	data: PricingCampaignTableRow[]
	isLoading: boolean
}) => {
	const table = useScenarioPricingCampaignsTable({
		scenario,
		isLoading,
		rowSelection,
		setRowSelection,
		data,
	})

	return (
		<div className='flex h-full flex-col gap-2'>
			<div
				role='toolbar'
				aria-orientation='horizontal'
				className='flex w-full items-start justify-between gap-2'
			>
				<SRT_TableToolbar table={table} />
			</div>
			<div className='border-base relative flex h-full flex-1 flex-col overflow-hidden rounded-lg border border-solid'>
				<MasterTable table={table} />
			</div>
		</div>
	)
}
